// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";

import { PageHeader, PageContent } from "components/layout";
import { trans } from "src/translations";

import { CreateEditOrganizationFormData } from "../_shared";

export class CreateOrganization extends Component {
  render() {
    return (
      <div>
        <PageHeader>{trans.ORGANIZATION__CREATE_PAGE_HEADER()}</PageHeader>
        <PageContent>
          <CreateEditOrganizationFormData isEdit={false} />
        </PageContent>
      </div>
    );
  }
}
